import { render, staticRenderFns } from "./UserCreateModal.vue?vue&type=template&id=3b9c6834&scoped=true"
import script from "./UserCreateModal.vue?vue&type=script&lang=js"
export * from "./UserCreateModal.vue?vue&type=script&lang=js"
import style0 from "./UserCreateModal.vue?vue&type=style&index=0&id=3b9c6834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c6834",
  null
  
)

export default component.exports